<div v-if="imageURL.length === 0" :class="$style.uploader">
  <div :class="$style.uploaderProcessing" v-if="uploading">
    <animation-processing :class="$style.spinner"></animation-processing>
  </div>
  <div v-else>
    <div id="qq-graphics-uploader-zone">
      <div
        :id="$vId(this, 'choose')"
        class="qq-uploader-selector qq-upload-button-selector"
        :class="$style.uploadZone">
        <upload-poster-icon :class="$style.uploadZoneIcon"></upload-poster-icon>
        <div>
          <div :class="$style.uploadZoneTitle">{{$t('pages.submissions.components.upload.uploader.drag_zone.title')}}</div>
          <div :class="$style.uploadZoneSubTitle">{{$t('pages.submissions.components.upload.uploader.drag_zone.subtitle')}}</div>
        </div>
        <div
          class="qq-upload-drop-area-selector"
          :class="$style.uploadZoneArea" qq-hide-dropzone>
          <span class="qq-upload-drop-area-text-selector"></span>
        </div>
        <ul
          class="qq-upload-list-selector"
          role="region"
          aria-live="polite"
          aria-relevant="additions removals">
        </ul>
      </div>     
    </div>
  </div>
</div>
